import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { IconButton, Popover } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import {
    Label,
    MobileWrapper,
    Wrapper,
    Info,
    Title,
    GridWrapper
} from '../../../Campaigns/Campaign/Campaign.styles';
import { SupportAnswer } from '../../../components/dialogs/SupportAnswer';
import { StyledPaper } from '../../../components/Popper/Popper.styles';
import { StyledRow } from './Question.styles';
import { QuestionProps } from './Question.interface';
import { createDate, sliceEmail } from '../../../utilities';

export function Question({ data, refresh }: QuestionProps) {
    const [isOpen, setIsOpen] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const idPopper = open ? 'simple-popper' : undefined; 
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    return (
        <>
            {isMobile ? 
                <MobileWrapper>
                    <Wrapper>
                        <div>
                            <Label>Id:</Label>
                            <Info>{data.id}</Info>
                        </div>
                        <IconButton onClick={handleClick}>
                            <MoreVert />
                        </IconButton>
                    </Wrapper>
                    <Label>Client:</Label>
                    <Title>{sliceEmail(data.user.email, 18)}</Title>
                    <Label>Subject:</Label>
                    <Title>{data.subject}</Title>
                    <GridWrapper>
                        <div>
                            <Label>Date:</Label>
                            <Info>{createDate(data.createDate)}</Info>
                        </div>
                        <div>
                            <Label>Answered:</Label>
                            <Info>{data.answered ? 'Yes': 'No'}</Info>
                        </div>
                    </GridWrapper>
                </MobileWrapper>
            :
                <StyledRow>
                    <p>{data.id}</p>
                    <p>{sliceEmail(data.user.email, 18)}</p>
                    <p>{data.subject}</p>
                    <p>{createDate(data.createDate)}</p>
                    <p>{data.answered ? 'Yes': 'No'}</p>
                    <IconButton onClick={handleClick}>
                        <MoreVert />
                    </IconButton>
                </StyledRow>
            }
            <Popover 
                    id={idPopper} 
                    open={open} 
                    anchorEl={anchorEl} 
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }} 
                >
                    <StyledPaper>
                        <button onClick={() => {
                            setAnchorEl(null);
                            setIsOpen(true);
                        }}>
                            {data.answered ? 'Show answer' : 'Answer'}
                        </button>
                    </StyledPaper>
            </Popover>
            <SupportAnswer open={isOpen} setOpen={setIsOpen} refresh={refresh} questionData={data} /> 
        </>
    )
}

